import React, { useContext, useEffect, useState } from 'react';
import { Card, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { Steps, Dropdown, Menu } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import '../participantList/participantList.css'; // Import your CSS file
import axios from 'axios';
import Swal from 'sweetalert2';
import UserContext from '../../Context/User/userContext';
import noRecord from '../../images/noRecord.png'
import { Typography } from '@mui/material';


const { Step } = Steps;

const ActiveStudyCardForUser = ({ setShowSpinner, id }) => {
    const [data, setData] = useState([]);
    const [file, setFile] = useState(null);
    const [stepNo, setStepNo] = useState("SMO");
    const [currentId, setCurrentId] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false); // State for modal visibility
    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";

    // User Object
    const { user, setUser } = useContext(UserContext);
    const _id = user && (typeof user === 'string' ? JSON.parse(user)._id : user._id);

    const handleModalOpen = (mystudyId) => {
        setIsModalVisible(true)
        setCurrentId(mystudyId)
    };

    const handleModalClose = () => {
        setIsModalVisible(false); // Hide modal
    };

    const handleFileUpload = () => {
        // Handle file upload logic here
        setIsModalVisible(false); // Hide modal after upload
        uploadDocument(stepNo, currentId, file)
    };

    const uploadDocument = (step, mystudyId, file) => {
        setShowSpinner(true);
        // Assuming 'file' is the file object obtained from the input element
        const formData = new FormData();
        formData.append('file', file); // 'file' should be the key expected by your backend for the file

        let folderName;
        if (step === "Protocol/FQ") {
            folderName = "Protocol";
        } else if (step === "Budget/CTA") {
            folderName = "Budget";
        } else {
            folderName = step;
        }

        // Prepare the URL with query parameters
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/document/${mystudyId}/${folderName}`;


        // Make the API request using Axios
        axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                // Handle success
                setShowSpinner(false);
                setFile(null);
                getData(tokenValue)
                // Perform actions like showing a success message, updating state, etc.
                Swal.fire({
                    title: "Document Recieved!",
                    text: "Your documents have been uploaded",
                    icon: "success",
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                })
            })
            .catch(error => {
                // Handle error
                setShowSpinner(false);
                setFile(null);
                // Show error message to user or retry logic
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
            });

    }

    const renderStepWithMenu = (title, showDiscription, userDoc, adminDoc, step, mystudyId) => {
        return (
            <Step
                title={title}
                description={showDiscription ?
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item
                                    key="1"
                                    onClick={e => {
                                        userDoc ?
                                            console.log('document already uploaded')
                                            : handleModalOpen(mystudyId)
                                    }}
                                >
                                    {userDoc ? <span style={{ color: "grey" }}>Uploaded</span> : 'Upload'}
                                </Menu.Item>
                                <Menu.Item key="2">
                                    {adminDoc ?
                                        <a href={adminDoc} target='_blank' download={'Current_StepDoc'}>
                                            Download
                                            <span style={{ color: 'green', fontSize: '24px' }} >•</span>
                                        </a>
                                        : 'Download'}
                                </Menu.Item>
                            </Menu>
                        }
                        trigger={['click']}
                    >
                        <EllipsisOutlined style={{ fontSize: '24px', cursor: 'pointer' }} />
                    </Dropdown>
                    : <></>
                }
            />
        )
    };

    const getData = () => {
        setShowSpinner(true);
        if (id) {
            axios.post(`https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/specific`,
                {
                    _id: id
                }, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`
                    // You can add other headers if needed like authorization token, etc.
                }
            })
                .then(res => {
                    const response = res.data.data
                    setData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    setShowSpinner(false);
                })
        } else {
            axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/${_id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${tokenValue}`
                        // You can add other headers if needed like authorization token, etc.
                    }
                })
                .then(res => {
                    const response = res.data.data
                    setData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    setShowSpinner(false);
                })
        }
    }

    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])

    const giveMeStepNo = (item) => {
        // Calculate the highest valid step outside of render
        let step = 0;
        const steps = [1, 2, 3, 4, 5, 6, 7];
        for (const s of steps) {
            if (item[`step${s}`]?.clear) {
                step = s;
            }
        }
        return step;
    }

    return (
        <>
            {
                data.length === 0 ?
                <div className='d-flex justify-content-center align-items-center'>
                <img width={500} height={500} src={require('../../images/nodataImg.webp')} alt="No Data Available" />
                </div>
                    :
                    data.map((v, i) => {
                        const currentStep = giveMeStepNo(v);
                        return (
                            <div className='p-3'>
                            <Card key={v._id} className='mt-1'>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <h6>Study Code</h6>
                                            <Link style={{ textDecoration: "none" }} to={`/myStudyForm/${v._id}`}>
                                                <p>{v.adminStudy.studyCode}</p>
                                            </Link>
                                        </Col>
                                        <Col>
                                            <h6>Study Title</h6>
                                            <p>{v.adminStudy.title}</p>
                                        </Col>
                                        <Col>
                                            <h6>Sponsor/CRO</h6>
                                            <p>{v.adminStudy.sponsorName}/{v.adminStudy.CRO}</p>
                                        </Col>
                                        <Col>
                                            <h6>Active Date</h6>
                                            <p>{v.adminStudy.activationDate}</p>
                                        </Col>
                                        <Col>
                                            <h6>Study Manager</h6>
                                            <p>{v.adminStudy.manager}</p>
                                        </Col>
                                        <Col>
                                            <h6>PI</h6>
                                            <p>{v.pi}</p>
                                        </Col>
                                        <Col>
                                            <h6>Status</h6>
                                            <p>{v.adminStudy.status}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                                <Card.Footer>
                                    <Row>
                                        <Col>
                                            <Steps current={currentStep} className="custom-steps">
                                                {
                                                    currentStep === 0 ?
                                                        renderStepWithMenu(
                                                            "SMO",
                                                            true,
                                                            v.step1.userDocument,
                                                            v.step1.adminDocument,
                                                            'step1',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "SMO",
                                                            false,
                                                            v.step1.userDocument,
                                                            v.step1.adminDocument,
                                                            'step1',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 1 ?
                                                        renderStepWithMenu(
                                                            "CDA",
                                                            true,
                                                            v.step2.userDocument,
                                                            v.step2.adminDocument,
                                                            'step2',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "CDA",
                                                            false,
                                                            v.step2.userDocument,
                                                            v.step2.adminDocument,
                                                            'step2',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 2 ?
                                                        renderStepWithMenu(
                                                            "Protocol/FQ",
                                                            true,
                                                            v.step3.adminDocument,
                                                            v.step3.adminDocument,
                                                            'step3',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "Protocol/FQ",
                                                            false,
                                                            v.step3.userDocument,
                                                            v.step3.adminDocument,
                                                            'step3',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 3 ?
                                                        renderStepWithMenu(
                                                            "PSSV",
                                                            true,
                                                            v.step4.userDocument,
                                                            v.step4.adminDocument,
                                                            'step4',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "PSSV",
                                                            false,
                                                            v.step4.userDocument,
                                                            v.step4.adminDocument,
                                                            'step4',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 4 ?
                                                        renderStepWithMenu(
                                                            "Budget/CTA",
                                                            true,
                                                            v.step5.userDocument,
                                                            v.step5.adminDocument,
                                                            'step5',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "Budget/CTA",
                                                            false,
                                                            v.step5.userDocument,
                                                            v.step5.adminDocument,
                                                            'step5',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 5 ?
                                                        renderStepWithMenu(
                                                            "SIV",
                                                            true,
                                                            v.step6.userDocument,
                                                            v.step6.adminDocument,
                                                            'step6',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "SIV",
                                                            false,
                                                            v.step6.userDocument,
                                                            v.step6.adminDocument,
                                                            'step6',
                                                            v._id
                                                        )
                                                }
                                                {
                                                    currentStep === 6 ?
                                                        renderStepWithMenu(
                                                            "Invoicing",
                                                            true,
                                                            v.step7.userDocument,
                                                            v.step7.adminDocument,
                                                            'step7',
                                                            v._id
                                                        )
                                                        :
                                                        renderStepWithMenu(
                                                            "Invoicing",
                                                            false,
                                                            v.step7.userDocument,
                                                            v.step7.adminDocument,
                                                            'step7',
                                                            v._id
                                                        )
                                                }
                                            </Steps>
                                        </Col>
                                    </Row>
                                </Card.Footer>
                            </Card>
                            </div>
                        )
                    })
            }
            <Modal show={isModalVisible} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Document</Form.Label>
                            <Form.Control type="file" onChange={e => setFile(e.target.files[0])} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Select Step</Form.Label>
                            <Form.Select type="select" value={stepNo} onChange={e => setStepNo(e.target.value)} >
                                <option value={'SMO'}>SMO</option>
                                <option value={'CDA'}>CDA</option>
                                <option value={'Protocol/FQ'}>Protocol/FQ</option>
                                <option value={'PSSV'}>PSSV</option>
                                <option value={'Budget/CT'}>Budget/CT</option>
                                <option value={'SIV'}>SIV</option>
                                <option value={'Invoicing'}>Invoicing</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleFileUpload}>
                        Upload
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );
};

export default ActiveStudyCardForUser;
